import React from 'react';
import LensToggle from './LensToggle';
import { useLens } from './LensContext';
import './Hero.css';

const abstracts = {
    strategist: (
        <>
            I run product like an operator: find the sharpest insight, define
            the bet, then build it myself so nothing is lost in translation.
            Currently CPO at Reltin. Twice a national hackathon winner.
        </>
    ),
    builder: (
        <>
            Full-stack &amp; AI engineer (React, Python, RAG pipelines) who
            treats every commit as a product decision. Google Summer of Code
            ’26 with NOAA. Open-source contributor.
        </>
    ),
};

function Hero() {
    const { lens } = useLens();

    return (
        <section id="hero" className="hero-doc">
            <div className="hero-inner">
                <div className="hero-topline">
                    <span className="mono-label">Spec no. 001 · Portfolio of work</span>
                    <span className="mono-label hero-topline-right">Rev. 2026 · Written &amp; built by hand</span>
                </div>

                <div className="hero-headline-wrap">
                    <h1 className="hero-headline">
                        <span className="hero-headline-line">
                            Thinks <em className="hero-word-product">product.</em>
                        </span>
                        <span className="hero-headline-line">
                            Ships <span className="code-chip hero-word-code">code.</span>
                        </span>
                    </h1>
                    <span className="stamp hero-stamp">Currently Building</span>
                </div>

                <div className="hero-subrow">
                    <p key={lens} className="hero-abstract lens-fade">
                        {abstracts[lens]}
                    </p>
                    <div className="hero-lens">
                        <span className="mono-label">Read this document as</span>
                        <LensToggle size="md" />
                    </div>
                </div>

                <dl className="hero-meta">
                    <div className="hero-meta-cell">
                        <dt className="mono-label">Name</dt>
                        <dd>Tanmay Rajurkar</dd>
                    </div>
                    <div className="hero-meta-cell">
                        <dt className="mono-label">Currently</dt>
                        <dd>CPO @ Reltin · GSoC ’26 @ NOAA</dd>
                    </div>
                    <div className="hero-meta-cell">
                        <dt className="mono-label">Status</dt>
                        <dd>
                            <span className="hero-status-dot" aria-hidden="true" />
                            Currently Building
                        </dd>
                    </div>
                    <div className="hero-meta-cell hero-meta-scroll">
                        <dt className="mono-label">Contents</dt>
                        <dd>
                            <a href="#about" className="link-ink">Begin reading ↓</a>
                        </dd>
                    </div>
                </dl>
            </div>
        </section>
    );
}

export default Hero;
